import React, { useEffect, useState } from "react";
import "../Wallet/styles/addCredit.scss";
import "../TicketManagement/style.scss";
import "../NewMember/RoleManagmentAndPermission/style.scss";
import { isEmpty, isNumber } from "../../utils/common";
import { useLocation, useNavigate } from "react-router-dom";
import { addDqrDevice, addBulkDqrCard, createInventory, addPosDevice } from "../../utils/api";
import { AlertWrapper } from "../../Components/Modal/style";
import LocalLoader from "../../Components/Loader/LocalLoader";
import PictureUpload from "../../Components/PictureUpload/PictureUpload";
import posBulkCsv from "../../assets/file/POS.csv";

const AddDevice = () => {
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [cardNumber, setCardNumber] = useState("");
  const [expDate, setExpDate] = useState("");
  const [csv, setCsv] = useState("");
  const navigate = useNavigate();
  const [tab, setTab] = useState("add");
   const location = useLocation();

  const editDeviceData = location.state?.editDeviceData;

  useEffect(()=>{
       if(isEmpty(editDeviceData))return;
       setCardNumber(editDeviceData?.serialNo);
       setExpDate(editDeviceData?.terminalNo);
  },[editDeviceData])

  const regex = /^[a-zA-Z0-9]*$/;


  const handleInput = (e) => {
    if (!regex.test(e.target.value) && !isEmpty(e.target.value)) return;
    setCardNumber((e.target.value).toUpperCase());
    setErrors("");
  };
  const handleChange = (event) => {
    const { value } = event.target;
      if (!regex.test(value) && !isEmpty(value)) return;
    if (regex.test(value)) {
      setExpDate(value.toUpperCase());
      setErrors("");
    }
  };

  const handleSubmit = () => {
    if (tab !== "add") {
      if (isEmpty(csv?.name)) {
        setErrors("Please upload csv");
        return;
      }
      let formData = new FormData();
      formData.append("file", csv);

      createInventory(formData).then((resp) => {
        setDisableBtn(false);
        setLoading(false);
        console.log("success", resp);
        if (resp?.data?.success) {
          setMessage({
            msg: "POS Devices detail add successfully.",
            type: "success",
          });
          setLoading(true);
          setTimeout(() => {
            navigate("/device-info");
            setDisableBtn(false);
            setLoading(false);
          }, 2000);
        } else {
          let msg = "";
          if (resp?.data?.errorCodeList.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
      });
    } else {
      if (isEmpty(cardNumber)) {
        setErrors("Please enter  Serial Number");
        return;
      }
      if (isEmpty(expDate)) {
        setErrors("Please enter Terminal Id");
        return;
      }
      const param = {
        deviceSerialNo: cardNumber,
        terminalId: expDate,
        deviceName:""
      };
setLoading(true);
      addPosDevice(param).then((resp) => {
      
     console.log("success----", resp);
        if (resp?.data?.success) {
         
          setMessage({
            msg: "POS Device detail add successfully.",
            type: "success",
          });
          setLoading(true);
          setTimeout(() => {
            navigate("/device-info");
       
            setLoading(false);
          }, 2000);
        } else {
            setLoading(false);
          let msg = "";
          if (resp?.data?.errorCodeList.length > 0) {
            msg = resp?.data?.errorCodeList[0];
          } else {
            msg = resp?.data?.msg;
          }
          setMessage({ msg: msg, type: "error" });
        }
      }).catch(()=>{
          setLoading(false);
          setMessage({ msg: "Something went wrong", type: "error" });
      })
    }
  };

  useEffect(() => {
    if (isEmpty(csv?.name)) return;
    setErrors("");
  }, [csv]);

  return (
    <>
      {loading && <LocalLoader className="tableLoader" />}
      {!isEmpty(message) && (
        <AlertWrapper className={`${message.type} globle`}>
          <span className="close" onClick={() => setMessage({})}>
            ×
          </span>
          {message.msg}
        </AlertWrapper>
      )}
      <div className="subadmin_main_container" style={{maxWidth:"600px"}}>
        <div className="subadmin_head flex space-between">
          <strong>{editDeviceData?"Update POS":"Add POS"}</strong>
        </div>
        <div className="subadmin_container">
          <div className="pd-30">
           { !editDeviceData && <div className="tabs flex">
              <div
                className={`tab ${tab === "add" ? "active" : ""}`}
                onClick={() => setTab("add")}
              >
                Add POS
              </div>
              <div
                className={`tab ${tab === "bulk" ? "active" : ""}`}
                onClick={() => setTab("bulk")}
              >
                Bulk Upload
              </div>
            </div>}

            <div className="flex form-container mg_top17">
              <div>
                {tab !== "add" && (
                  <lable className="filter_text fs">upload CSV</lable>
                )}
                <div className="mg-top3 flex" style={{ gap: "10px" }}>
                  {tab === "add" ? (
                    <>
                      <input
                        type="text"
                        name="CardNumber"
                        value={cardNumber}
                        className="filter_select  fs"
                        placeholder="Enter Serial Number"
                        onChange={handleInput}
                       
                      />
                      <div className="flex" style={{ gap: "10px" }}>
                        <input
                          type="text"
                          name="expiryDate"
                          value={expDate}
                          className="filter_select  fs"
                          placeholder="Enter Terminal Id"
                          onChange={handleChange}
                       
                        />
                      </div>
                    </>
                  ) : (
                    <PictureUpload
                      setImage={setCsv}
                      image={csv}
                      accept=".csv"
                      type="file"
                    />
                  )}
                </div>
                {tab !== "add" && (
                  <a
                    sty
                    download={"POS_inventory_simple.csv"}
                    href={posBulkCsv}
                    style={{ fontSize: "14px" }}
                  >
                    Download Simple file
                  </a>
                )}

                {!isEmpty(errors) && (
                  <p className="error fs-12 mt-10">{errors}</p>
                )}
              </div>
            </div>

            <div className="flex form-container">
              <button
                onClick={handleSubmit}
                style={{
                  width: "100%",
                  height: "45px",
                  marginTop: "25px",
                  marginBottom: "20px",
                }}
                disabled={disableBtn}
                className={
                  disableBtn
                    ? "ticket_input-field_button_disable"
                    : "userlist_btn"
                }
              >
                {editDeviceData?"Update":"Add"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AddDevice;
